import { ILead } from '@clickersphere/core/entities/ILead';
import { Button } from '../../Button';
import Select from '../../Select';
import { Textarea } from '../../Textarea';
import { useDeactivateLeadModalController } from './useDeactivateLeadModalController';

interface IDeactivateLeadModalProps {
  lead: ILead;
}

export default function DeactivateLeadModal({
  lead,
}: IDeactivateLeadModalProps) {
  const {
    t,
    reasonOptions,
    lostReason,
    setLostReason,
    note,
    setNote,
    noteError,
    isPending,
    handleConfirm,
    handleClose,
  } = useDeactivateLeadModalController(lead);

  return (
    <div className="my-4 flex w-full flex-col gap-4">
      <p className="text-text-secondary text-sm">
        {t('lead.deactivate.description')}
      </p>

      <Select
        placeholder={t('lead.deactivate.reasonPlaceholder')}
        options={reasonOptions}
        value={lostReason}
        emptyOption
        emptyOptionLabel={t('lead.deactivate.reasonNone')}
        onChange={setLostReason}
        disabled={isPending}
      />

      <Textarea
        name="lostReasonNote"
        placeholder={t('lead.deactivate.notePlaceholder')}
        value={note}
        onChange={(event) => setNote(event.target.value)}
        error={noteError}
        disabled={isPending}
      />

      <section className="mt-2 flex flex-col gap-2 sm:flex-row sm:gap-4">
        <Button
          color="ghost"
          labelPath="lead.deactivate.cancel"
          className="w-full sm:w-40"
          disabled={isPending}
          onClick={handleClose}
        />
        <Button
          color="danger"
          labelPath="lead.deactivate.confirm"
          className="w-full sm:flex-1"
          isLoading={isPending}
          disabled={isPending || !!noteError}
          onClick={handleConfirm}
        />
      </section>
    </div>
  );
}
